import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";

const ScrollableArea = _ref => {
  let {
    children,
    maxWidth,
    maxHeight,
    className
  } = _ref;
  if (!children) return null;
  const classes = classNames('u-overflow-auto', className);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    style: {
      maxWidth,
      maxHeight
    },
    children: children
  });
};

export default ScrollableArea;